import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { assert } from '@ember/debug';
import { isNone } from '@ember/utils';
import type IntlService from 'ember-intl/services/intl';
import type { htmlSafe } from '@ember/template';
type SafeString = ReturnType<typeof htmlSafe>;

export interface AditoolsHelpDialogSignature {
  Element: HTMLDialogElement;
  Args: {
    title: string | SafeString;
    close?: () => void;
    closeButtonText?: string;
    dialogClass?: string;
    message?: string | SafeString;
    suppressFocusTrap?: boolean;
  };
  Blocks: {
    default: [];
  };
}
type AditoolsHelpDialogArgs = AditoolsHelpDialogSignature['Args'];

export default class AditoolsHelpDialog extends Component<AditoolsHelpDialogSignature> {
  @service declare intl: IntlService;

  constructor(owner: unknown, args: AditoolsHelpDialogArgs) {
    super(owner, args);
    assert('`title` is required', !isNone(this.args.title));
  }

  // Optional parameters with defaults applied
  get _message() {
    return this.args.message ?? '';
  }

  get _closeButtonText() {
    return this.args.closeButtonText ?? this.intl.t('ember-aditools-page.common.close');
  }

  get _suppressFocusTrap() {
    return this.args.suppressFocusTrap ?? false;
  }
  @action close() {
    if (this.args.close) {
      this.args.close();
    }
  }
}
